import _ from 'lodash';

export class Codes {
	static userTp(code:string):string {
		let userTp:string ='';
		switch(code) {
			case '0': {
				userTp = '일반회원';
				break;
			}
			case '1': {
				userTp = '기업회원';
				break;
			}
			case '99': {
				userTp = '내부사용자';
				break;
			}
		}
		return userTp;
	}

	
	static userJobTp (code:string):string {
		let jobTp:string ='';
		switch(code) {
			case '0': {
				jobTp = '화주';
				break;
			}
			case '1': {
				jobTp = '포워더';
				break;
			}
			case '2': {
				jobTp = '선사';
				break;
			}
			case '99': {
				jobTp = '기타';
				break;
			}
		}
		
		return jobTp;
	}

	static lclPkgUnit(code): string {
		let pkgUnitStr:string ='';
		switch(code) {
      case 0:
      case '0': 
				pkgUnitStr = 'Pallets';
				break;
			case 1 :
			case '1': 
				pkgUnitStr = 'Cartons';
				break;
			case 2 :
      case '2': 
				pkgUnitStr = 'Boxes';
				break;
      case 3 :
      case '3': 
				pkgUnitStr = 'Other';
				break;
      case 4 :
      case '4': 
				pkgUnitStr = 'Crates';
				break;
      case 5 :
      case '5': 
				pkgUnitStr = 'Drums';
				break;
      case 6 :
      case '6': 
				pkgUnitStr = 'Bags';
				break;
      case 7 :
      case '7': 
				pkgUnitStr = 'Bales';
				break;
      case 8 :
      case '8': 
				pkgUnitStr = 'Bundles';
				break;
      case 9 :
      case '9': 
				pkgUnitStr = 'Cans';
				break;
      case 10 :
      case '10': 
				pkgUnitStr = 'Carboys';
				break;
      case 11 :
      case '11': 
				pkgUnitStr = 'Carpets';
				break;
      case 12 :
      case '12': 
				pkgUnitStr = 'Cases';
				break;
      case 13 :
      case '13': 
				pkgUnitStr = 'Coils';
				break;
      case 14 :
      case '14': 
				pkgUnitStr = 'Cylinders';
				break;
      case 15 :
      case '15': 
				pkgUnitStr = 'Loose';
				break;
      case 16 :
      case '16': 
				pkgUnitStr = 'Pails';
				break;
      case 17 :
      case '17': 
				pkgUnitStr = 'Reels';
				break;
      case 18 :
      case '18': 
				pkgUnitStr = 'Rolls';
				break;
      case 19 :
      case '19': 
				pkgUnitStr = 'Tubes';
				break;
      case 20 :
      case '20': 
				pkgUnitStr = 'Pipes';
				break;
		}

		return pkgUnitStr;
  }
  
  static checkTempUnit(code): string {
    if(code == 'C') return '℃';
    if(code == 'F') return '℉';
  }

  static hsCodeSplit(code): string {
    var formatHsCode:string = '';
    if (!code || !code.length) return null;
    if(code.length < 6) {
      return code;
    } else if(code.length == 6) {
      formatHsCode = code.replace(/(\d{4})(\d{2})/, '$1.$2');
    } else {
      let codeArray = code.split('');
      let first = [];
      let second = [];
      let third = [];
      for(let i=0; i<codeArray.length; i++) {
        if(i < 4) {
          first.push(codeArray[i]);
        } else if(i == 4 || i == 5) {
          second.push(codeArray[i]);
        } else {
          third.push(codeArray[i]);
        }
      }

      formatHsCode = _.join(first, '') + '.' + _.join(second, '') + '-' + _.join(third, '');
    }
    return formatHsCode;
  }
}


// WEBPACK FOOTER //
// ./src/app/utils/codes.ts